module.exports = __webpack_public_path__ + "img/zanwu.7d3f76a3.png";